import { cloneDeep, isEqual } from 'lodash';

import BaseDropdown from './dropdown';

class MerchantDropdown extends BaseDropdown {
	constructor(props) {
		super(props);

		this.type = 'merchants';
		// List item can be targeted by the merchant slug, e.g. $('.dropdown-item.macys')
		this.identifierField = 'slug';
		this.hasSearch = true;

		this.state = {
			merchants: this.props.items,
			opened: false,
			focusIndex: null,
			label: this.getLabel(this.props.items),
			...(this.props.statType === 'merch-ed-overview' && {
				label: 'Search for a merchant...',
				activeOnly: this.props.activeOnly,
				reconciledOnly: this.props.reconciledOnly,
			}),
		};
	}

	componentDidUpdate(prevProps) {
		if (!isEqual(prevProps.items, this.props.items)
			|| prevProps.activeOnly !== this.props.activeOnly
			|| prevProps.reconciledOnly !== this.props.reconciledOnly) {
			const merchants = this.getSelectedMerchants(this.props.items);
			this.setState({
				merchants: merchants,
				...(this.props.statType !== 'merch-ed-overview' && {
					label: this.getLabel(this.props.items),
				}),
				...(this.props.statType === 'merch-ed-overview' && {
					activeOnly: this.props.activeOnly,
					reconciledOnly: this.props.reconciledOnly,
				}),
			});
		}
	}

	update() {
		let merchants = this.getSelectedMerchants(this.state.merchants);

		this.setState({
			merchants: merchants,
			...(this.props.statType !== 'merch-ed-overview' && {
				label: this.getLabel(merchants),
			}),
		}, () => {
			if (this.props.statType === 'merch-ed-overview') {
				const {activeOnly, reconciledOnly} = this.state;
				this.props.updateMerchantParams(merchants, activeOnly, reconciledOnly);
			} else if (this.props.statType === 'insights') {
				const resetCarousel = merchants.length === merchants.filter((merch) => merch.selected).length;
				this.props.updateMerchants(merchants, false, resetCarousel);
			} else {
				this.props.updateMerchants(merchants);
			}

			const merchIds = merchants.filter((m) => m.selected).map((m) => m.merch_id);
			this.AnalyticService.trackEvent(
				this.props.gaEvent.category, 'Execute',
				`${this.props.gaEvent.label} ${merchIds.join(',')}`
			);
		});
	}

	resetColumns(selectedState) {
		// Create deep copy to prevent mutating state object directly
		let merchants = cloneDeep(this.state.merchants);
		merchants = merchants.filter((merch) => !merch.hidden).map((merch) => {
			merch.selected = selectedState;
			return merch;
		});
		this.setState({merchants: merchants});
	}

	getSelectedMerchants(merchants) {
		let newMerchants = cloneDeep(merchants);
		// If no merchants selected, select all merchants instead
		if (newMerchants && !newMerchants.filter((merch) => merch.selected).length) {
			newMerchants = newMerchants.map((merch) => {
				merch.selected = true;
				return merch;
			});
		}

		return newMerchants;
	}

	getLabel(merchants) {
		let totalMerchants = 0; // Count non-hidden merchants
		let numSelected = 0;
		let label;
		merchants.forEach((merch) => {
			if (merch.selected) numSelected += 1;
			if (!merch.hidden) totalMerchants += 1;
		});

		if (numSelected === 0 || numSelected === totalMerchants) {
			label = 'All Merchants';
		} else if (numSelected === 1) {
			label = merchants.find((merch) => merch.selected).label;
		} else {
			label = `${numSelected} Merchants`;
		}

		return label;
	}
}

export default MerchantDropdown;
